// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P88l","right":"styles_right__26vBz"};